import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { setLastActive } from '../actions/appActions';
import { resetCart } from '../actions/orderActions';
import { ACCESS_SERVICES_MAP, APP_SERVICE, INACTIVE_EXPIRE_TIME, PARAMS_NAME } from '../constants';
import { getRestaurantId } from '../selectors'
import useDidMountEffect from './useDidMountEffect';
import paths from '../routes/paths';
import qs from 'query-string';

const useLastActive = () => {
    const lastActive = useSelector(state => state.AppReducer.lastActive)
    const restaurantId = useSelector(getRestaurantId)
    const location = useLocation()
    const dispatch = useDispatch()

    useEffect(() => {
        let timeOut
        const handelSetLastActive = () => {
            timeOut && clearTimeout(timeOut)
            timeOut = setTimeout(() => {
                dispatch(setLastActive(new Date().getTime()))
            }, 1000);
        }

        document.addEventListener('mousedown', handelSetLastActive)
        document.addEventListener('touchstart', handelSetLastActive)

        return () => {
            timeOut && clearTimeout(timeOut)
            document.removeEventListener('mousedown', handelSetLastActive)
            document.removeEventListener('touchstart', handelSetLastActive)
        }
    }, [])

    useEffect(() => {
        const params = qs.parse(location.search);
        if (
            APP_SERVICE !== ACCESS_SERVICES_MAP.WEB ||
            !lastActive ||
            params[PARAMS_NAME.ORDER_GO_ID] ||
            params[PARAMS_NAME.ORDER_WEB_ID]
        ) {
            return;
        }

        let handleTimeout

        const handleExpire = () => {
            const currentMillisecondsTime = new Date().getTime()
            const timeout = Math.abs(currentMillisecondsTime - lastActive - INACTIVE_EXPIRE_TIME)

            handleTimeout = setTimeout(() => {
                dispatch(resetCart())
                window.location.href = `/${restaurantId}${paths.listFood}`
            }, timeout);
        }

        const handleExpireAfterVisible = () => {
            if ('visible' === document.visibilityState) {
                handleExpire()
            }
        }

        handleExpire()
        document.addEventListener('visibilitychange', handleExpireAfterVisible)

        return () => {
            handleTimeout && clearTimeout(handleTimeout)
            document.removeEventListener('visibilitychange', handleExpireAfterVisible)
        }
    }, [ lastActive, location.search ]);

    useDidMountEffect(() => {
        dispatch(setLastActive(new Date().getTime()))
    }, [ location.pathname ])
}

export default useLastActive
